// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__WhLFP","preloader":"Preloader_preloader__Ew-1r"};